<template>
  <wh-popup
    v-model="myVisible"
    :title="title"
    :ref-form="$refs.PackingPopup"
    @close="hidePopup"
    @open="open"
  >
    <van-form
      ref="PackingPopup"
      class="packing-popup"
      label-width="60px"
      @submit="submitForm"
    >
      <div class="main">
        <van-field
          v-model="form.productName"
          label="产品名称"
          name="产品名称"
          placeholder="请输入产品名称"
          :rules="rules.productName"
        />
        <wh-popup-select
          v-model="form.raw"
          placeholder="请输入原料"
          class="raw-selete"
          :columns="rawListSelect"
          label="原料"
          @change="changeFn"
        />
        <div v-for="(i,key) in form.rawMaterialsInventoryRecordsInfo||[]" :key="key">
          <div v-if="!i.deleted" class="raw-list wh-flex-between">
            <div class="material-name van-ellipsis">
              {{ i.materialName }}
            </div>
            <div>库存：{{ i.quantity }}</div>
            <div class="wh-flex-start count" style="width: 100px">
              <span>用量：</span>
              <van-field v-model.number="i.recordsQuantity" type="number" :disabled="i.flag" class="quantity" input-align="center" />
              <span>
                {{ i.materialUnit }}
              </span>
            </div>
            <div>
              <van-icon v-if="!i.flag" name="checked" color="#20CAA0" size="20" @click="subRaw(i)" />
              <svg-icon v-else icon-class="edit" style="width:20px;height:20px" @click.native="i.flag = !i.flag" />
              <van-icon name="delete" color="#FF4444" size="20" @click="delRaw(i,key)" />
            </div>
          </div>
        </div>
        <wh-popup-select
          v-model="form.process"
          :disabled="formType!=='create'"
          :columns="processListSelect"
          label="加工过程"
          placeholder="请选择加工过程"
          :rules="rules.process"
          @change="changeProcessFn"
        />
        <van-field :value="form.specificationQuantity" :rules="rules.unit" label="包装规格">
          <template #input>
            <div class="unit-box">
              <van-stepper
                v-model.number="form.specificationQuantity"
                :min="0"
                input-width="60px"
                decimal-length="2"
              />
              <wh-select-popup v-model="form.specificationUint" :options="unitOptions" placeholder="单位" />
              <wh-select-popup v-model="form.specificationPacking" :options="packOptions" placeholder="单位" />
            </div>
          </template>
        </van-field>
        <van-field :value="form.packingQuantity" :rules="rules.packingQuantity" label="数量">
          <template #input>
            <van-stepper
              v-model.number="form.packingQuantity"
              :min="0"
              input-width="80px"
            />
          </template>
        </van-field>
        <wh-field-time-popup v-model="form.packingTime" :rules="rules.packingTime" label="包装时间" input-align="left" />
        <wh-staff v-model="form.staffName" :rules="rules.staffName" lable="操作人" />
        <van-field
          v-model="form.productIntroduction"
          placeholder="请输入产品简介"
          label="产品简介"
          maxlength="200"
          autosize=""
          rows="3"
          type="textarea"
          show-word-limit
        />
        <div style="padding:0 16px">
          <wh-upload v-model="form.photo" :files-str.sync="photoStr" :max-count="3" />
        </div>
      </div>
    </van-form>
  </wh-popup>
</template>
<script>
import api from '@/api'
import WhPopup from '@/components/public/WhPopup/WhPopup'
import { unitOptions, packOptions } from '@/constant/common'
import { formPopup } from '@/utils/mixins/formPopup'
import WhPopupSelect from '@/components/public/WhPopupSelect/WhPopupSelect.vue'
import WhSelectPopup from '@/components/public/WhSelectPopup/WhSelectPopup'
import WhFieldTimePopup from '@/components/public/WhFieldTimePopup/WhFieldTimePopup'
import WhStaff from '@/components/public/WhStaff/WhStaff.vue'
import WhUpload from '@/components/public/WhUpload/WhUpload.vue'

export default {
  components: { WhPopup, WhPopupSelect, WhSelectPopup, WhFieldTimePopup, WhStaff, WhUpload },
  mixins: [formPopup],
  data() {
    const unitValidator = (value, rule) => {
      return !!this.form.specificationQuantity && !!this.form.specificationUint && !!this.form.specificationPacking
    }
    return {
      unitOptions,
      packOptions,
      rules: {
        productName: [{ required: true, message: '请输入产品名称' }],
        process: [{ required: true, message: '请选择加工过程', trigger: 'onChange' }],
        unit: [{ validator: unitValidator, message: '请选择完整的包装规格' }],
        packingQuantity: [{ validator: val => val >= 0, message: '请输入包装数量' }],
        packingTime: [{ required: true, message: '请选择包装时间' }],
        staffName: [{ required: true, message: '请选择操作人' }]
      },
      form: {
        productName: '',
        id: undefined,
        packingQuantity: 0,
        packingTime: '',
        photo: [],
        processingJson: {},
        productIntroduction: '',
        rawMaterialsInventoryRecordsInfo: [],
        specificationPacking: 'g',
        specificationQuantity: undefined,
        specificationUint: '袋',
        staffName: ''
      },
      photoStr: '',
      rawListSelect: [],
      processList: [],
      processListSelect: [],
      selectRowList: [],
      rawList: []
    }
  },
  computed: {
    title() {
      return this.formType === 'create' ? '新增包装' : '编辑包装'
    }
  },
  watch: {
    visible: {
      handler(newV) {
        this.$nextTick(() => {
          this.$refs.PackingPopup.resetValidation()
        })
      }
    }
  },
  methods: {
    unique(arr) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1))
    },
    getrawList() {
      this.rawList = []
      this.rawListSelect = []
      api.getRawMaterialsStockList().then(res => {
        this.rawList = res.data.list
        res.data.list.forEach(i => {
          if (i.quantity) {
            this.rawListSelect.push({
              text: `${i.materialName}  剩余:${i.quantity}`,
              value: i.id
            })
          }
        })
      })
    },
    getProcessList() {
      this.processList = []
      this.processListSelect = []
      api.getProcessing().then(res => {
        this.processList = res.data.list
        res.data.list.map(i => {
          this.processListSelect.push({
            text: i.craftName,
            value: i.id
          })
        })
      })
    },
    subRaw(i) {
      if (i.recordsQuantity > i.quantity) {
        this.$toast.fail('输入数量超过库存')
        return
      } else {
        i.flag = true
      }
    },
    delRaw(row, index) {
      this.$dialog.confirm({
        message: '确认删除?'
      }).then(() => {
        if (row.id) {
          this.form.rawMaterialsInventoryRecordsInfo.splice(index, 1)
          return
        }
        if (row.deleted === 0) {
          row.deleted = 1
          return
        }
      }).catch(() => {})
    },
    changeFn(val) {
      this.rawList.map(item => {
        if (item.id === val && item.quantity) {
          this.form.rawMaterialsInventoryRecordsInfo.push({
            ...item,
            rawMaterialsInventoryRecordsId: null,
            stockId: item.id,
            recordsQuantity: 0,
            lastrecordsQuantity: 0,
            flag: false,
            deleted: 0
          })
        }
      })
    },
    changeProcessFn(val) {
      this.processList.map(item => {
        if (item.id === val) {
          this.form.processingJson = { ...item }
        }
      })
    },
    submitForm() {
      if (!this.form.rawMaterialsInventoryRecordsInfo.length) {
        this.$toast.fail('原料未选择')
        return
      } else {
        if (this.form.rawMaterialsInventoryRecordsInfo.some(i => { return !i.flag })) {
          this.$toast.fail('部分原料未确定')
          return
        }
      }
      if (this.form.id) {
        const editForm = {
          ...this.form,
          photo: this.photoStr,
          rawMaterialsInventoryRecordsInfo: this.form.rawMaterialsInventoryRecordsInfo.map(item => {
            return {
              ...item,
              recordsQuantity: -item.recordsQuantity
            }
          })
        }
        api.updatePackingManagement(editForm).then(res => {
          this.$toast('编辑包装成功')
          this.hidePopup()
          this.submitFormSuccess()
        })
      } else {
        const createForm = {
          ...this.form,
          photo: this.photoStr,
          rawMaterialsInventoryRecordsInfo: this.form.rawMaterialsInventoryRecordsInfo.map(item => {
            return {
              ...item,
              recordsQuantity: -item.recordsQuantity
            }
          })
        }
        api.createPackingManagement(createForm).then(res => {
          this.$toast('添加包装成功')
          this.hidePopup()
          this.submitFormSuccess()
        })
      }
    },
    async open() {
      await this.getrawList()
      await this.getProcessList()
      if (this.formType === 'create') {
        this.formDataInit(this.form)
      } else {
        this.formDataInit(this.form, this.initFormData)
        if (this.form.processingJson) {
          this.form.process = this.form.processingJson.id
        }
        if ((this.form.rawMaterialsInventoryRecordsInfo || []).length) {
          this.form.rawMaterialsInventoryRecordsInfo = this.form.rawMaterialsInventoryRecordsInfo.map(i => {
            return {
              ...i,
              recordsQuantity: Math.abs(i.recordsQuantity),
              flag: true,
              deleted: 0
            }
          })
        }
      }
    }
  }

}
</script>
<style lang="less" scoped>
.main{
  background-color: #fff;
  .raw-selete{
    /deep/.van-field__control{
      display: none;
    }
  }
  .raw-list{
    padding: 5px 16px;
    margin-bottom: 2px;
    font-size: 12px;
    background-color: rgba(32, 202, 160, 0.12);
    word-break: keep-all;
    .material-name {
      width: 100px;
        &::before{
          content: '';
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: #20CAA0;
          margin-right: 6px;
          margin-bottom: 2px;
        }
    }
    .quantity{
      width: 60px;
      font-size: 12px;
      padding: 0;
      background-color: #fff;
    }
  }
  .unit-box{
      display: flex;
      flex-wrap: wrap;
  }
}
</style>
